import { ChargeSettle } from 'src/app/model/interfaces/charge-settle';
import { ApiPostRequest } from '../api-post-request';

export class ChargeSettleRequest extends ApiPostRequest
{
    public constructor(payload: ChargeSettle, webapiBasepath: string)
    {
        super('billwerk/chargesettle',
        null,
        null,
        payload,
        webapiBasepath
    );
    }
}
